import { useQuery } from '@tanstack/react-query'

import { QueryKey } from 'consts/query/queryKey'

import { getUsers } from './requests'

export const useUsersQuery = () => {
  return useQuery({
    queryKey: [QueryKey.GetUsers],
    queryFn: () => getUsers(),
  })
}
